import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "@/components/landing/Reveal";
import { useI18n } from "@/lib/i18n";

export default function FAQ() {
  const { t } = useI18n();
  const items = t("faq.items") || [];
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 sm:py-32 bg-stone-100/60 dark:bg-neutral-950/50"
    >
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Reveal>
          <div className="text-center">
            <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-emerald-800 dark:text-emerald-400">
              {t("faq.kicker")}
            </div>
            <h2 className="mt-4 font-display font-bold text-4xl sm:text-5xl tracking-tight leading-tight text-balance text-neutral-900 dark:text-neutral-50">
              {t("faq.h2")}
            </h2>
          </div>
        </Reveal>

        <Reveal delay={0.08}>
          <div className="mt-12 rounded-3xl border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-neutral-900 p-2 sm:p-4">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {items.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="px-4 sm:px-6 border-b last:border-none border-neutral-200 dark:border-neutral-800"
                >
                  <AccordionTrigger className="py-5 text-left text-base sm:text-lg font-display font-semibold text-neutral-900 dark:text-neutral-50 hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-5 text-[15px] text-neutral-600 dark:text-neutral-300 leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
